import React from "react";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import  Routes  from "../src/constants/routes";

function App() {
  return (
    <BrowserRouter>
    <Routes>
    </Routes>
    </BrowserRouter>
  );
}

export default App;
